import { render, staticRenderFns } from "./QuickOrder.vue?vue&type=template&id=467bdb04&scoped=true&"
import script from "./QuickOrder.vue?vue&type=script&lang=js&"
export * from "./QuickOrder.vue?vue&type=script&lang=js&"
import style0 from "./QuickOrder.vue?vue&type=style&index=0&id=467bdb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bdb04",
  null
  
)

export default component.exports